import { useEffect } from "react";
import { useNavigate } from "react-router";
import { getRequest, getRequestWithAuth } from "~/lib/api";
import { setSession, setUser } from "~/lib/session";
import { useAuth } from "~/contexts/AuthContext";
import AuthLoading from "~/components/auth-loading/auth-loading";

export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const paramsObj = Array.from(urlParams.keys()).reduce(
          (acc, val) => ({ ...acc, [val]: urlParams.get(val) }),
          {}
        );
        const microsoftCallbackPath = `/api/v1/auth/microsoft/callback`;
        const data = await getRequest(microsoftCallbackPath, { params: paramsObj });
        setSession(data.access_token, data.token_type);
        const user = await getRequestWithAuth("/api/v1/users/me");
        setUser(user);

        // Refresh auth context with new user
        await refreshAuth();

        navigate("/session");
      } catch (error) {
        console.error("Microsoft auth callback failed:", error);
        navigate("/login");
      }
    };

    handleCallback();
  }, [navigate, refreshAuth]);

  return <AuthLoading />;
}
